import { h } from 'preact'; /** @jsx h */
import { useRef } from 'preact/hooks';
import useWindowSize from '../../utils/windowSize';

import InputField from '../InputField/InputField';

import './SavedUserInfo.scss';

const SavedUserInfo = ({ user, setUser, errors, setErrors }) => {
    // Check if user is on tablet
    const { width: windowWidth } = useWindowSize();
    const isMobile = windowWidth <= 768;

    const emailRef = useRef();
    const consentRef = useRef();

    // Format phone number
    const formatPhonenumber = number => {
        if (number.length === 8) {
            return number.replace(/(\d{3})(\d{2})(\d{3})/, '$1 $2 $3');
        }

        return number;
    };

    const handleSaveClick = () => {
        if (!emailRef.current.value) {
            setErrors({ ho_epost: 'E-post er påkrevd' });
            return;
        }

        // Email validation
        const emailRegex = /\S+@\S+\.\S+/;
        if (emailRef.current.value && !emailRegex.test(emailRef.current.value)) {
            setErrors({ ho_epost: 'E-post er ikke gyldig' });
            return;
        }

        // If there are no errors, save the user to local storage and set the user state
        localStorage.setItem(
            'snla-user',
            JSON.stringify({
                ...user,
                ho_epost: emailRef.current.value,
                ho_epost_samt: consentRef.current.checked ? 'J' : 'N'
            })
        );
        setUser(prevUser => ({
            ...prevUser,
            ho_epost: emailRef.current.value,
            ho_epost_samt: consentRef.current.checked ? 'J' : 'N'
        }));
    };

    return (
        <div className="user-info-content delivery-info">
            <p className="user-info top name">
                {user?.ho_fnavn} {user?.ho_enavn}
            </p>
            <p className="user-info top address">{user?.adresse1},</p>
            <p className="user-info top zipcode">
                {user?.postnr} {user?.poststed}
            </p>
            <div className="user-info-divider" />
            <p className="user-info bottom mobile">
                <span className="material-symbols-outlined">call</span>
                +47 {formatPhonenumber(user?.ho_mobilnr)}
            </p>
            {user?.ho_epost ? (
                <p className="user-info bottom email">
                    <span className="material-symbols-outlined">mail</span>
                    {user?.ho_epost}
                </p>
            ) : (
                <div className="missing-email-container">
                    <p className="missing-email-text user-info bottom email">
                        <span className="material-symbols-outlined">mail</span>
                        Vi mangler din e-postadresse for å kunne sende deg informasjon om din ordre.
                        <br />
                        Vennligst legg inn din e-postadresse under for å fortsette.
                    </p>
                    <div className="input-container">
                        <div className="input-row">
                            <InputField
                                label={'E-post*'}
                                name="ho_epost"
                                value={user?.ho_epost}
                                errorMessage={errors.ho_epost}
                                ref={emailRef}
                                required
                            />
                            {!isMobile && (
                                <div className="button-container">
                                    <button
                                        className="ws-change-info-btn"
                                        onClick={() => handleSaveClick()}
                                    >
                                        Lagre
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="checkbox-container">
                            <InputField
                                type="checkbox"
                                label={
                                    'Ja, jeg vil holde meg oppdatert på arbeidet til Stiftelsen Norsk Luftambulanse.'
                                }
                                name="ho_epost_samt"
                                checked={user?.ho_epost_samt === 'J'}
                                ref={consentRef}
                            />
                        </div>
                        {isMobile && (
                            <div className="button-container mobile">
                                <button
                                    className="ws-change-info-btn mobile"
                                    onClick={() => handleSaveClick()}
                                >
                                    Lagre
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SavedUserInfo;
